import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Guid } from 'guid-typescript';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { Equipment } from '../models/equipment';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class EquipmentService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }


  public add(equip): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.post<Equipment>(environment.apiUrl + 'jobequipment/PostFromWeb',equip).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }
  public update(equip): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.post<Equipment>(environment.apiUrl + 'jobequipment/put',equip).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public delete(id: string): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.get<Equipment>(environment.apiUrl + 'equipment/delete?core_Id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }
  
  public getByLocation(location_Id: number): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      //console.log(environment.apiUrl + 'equipment/getbylocation?location_Id=' + location_Id);
      this.http.get<Equipment>(environment.apiUrl + 'equipment/getbylocation?location_Id=' + location_Id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public getforQuote(location_Id: number, category_Id: number, serial_Num: string, asset_Num: string): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      let params = '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;

      //console.log(environment.apiUrl + 'equipment/getforQuote?location_Id=' + location_Id);
      this.http.get<Equipment>(environment.apiUrl + 'equipment/getforquote?location_Id=' + location_Id + params).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }
  public get(id: string): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      this.http.get<Equipment>(environment.apiUrl + 'jobequipment/GetById?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  public getDescriptions(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'equipment/getDescriptions').subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }

  //public getDescriptions(): Promise<any> {
  //  return new Promise((resolve, reject) => {
  //    this.http.get<any>(environment.apiUrl + 'equipment/Get').subscribe(data => {
  //      resolve(data);
  //    }, error => {
  //      //console.log(error);
  //      reject();
  //    });
  //  });
  //}

  public save(equipment: Equipment): Promise<Equipment> {
    return new Promise((resolve, reject) => {
      if (equipment.is_edit) {
        this.http.put<Equipment>(environment.apiUrl + 'jobequipment/put', equipment).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated equipment');
        }, error => {
          //console.log(error);
          reject();
        });
      } else {
        equipment.core_Id = Guid.create().toString();

        this.http.post<Equipment>(environment.apiUrl + 'jobequipment/post', equipment).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added equipment');
        }, error => {
          //console.log(error);
          reject();
        });
      }
    });
  }
  public uploadFile(id: string, base64String: string, fileName: string): Promise<any> {
    var dto = {
      Location_Inspection_Id: id,
      Base64String: base64String,
      File_Name: fileName
    };

    return new Promise((resolve, reject) => {
      this.http.post(environment.apiUrl + 'equipment/uploadFile', dto).subscribe(data => {
        this.snotifyService.success('Successfully uploaded file');
        resolve(data);
      }, error => {
        reject(error.error);
      });
    });
  }

  public removeFile(id: string, file_Name: string) {
    return this.http.delete("/api/equipment/removeFile?equipment_id=" + id + "&file_Name=" + file_Name);
  }

  public getFiles(page: Page, id: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();
    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'File_Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&equipment_id=' + id;

      this.http.get<ServerData>(environment.apiUrl + 'equipment/getuploadedfiles?size=' + page.size + '&pageNumber=' + page.pageNumber + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;

        //console.log(pagedData);

        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }


  public getResults(page: Page, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, asset_Num: string, contract_No: string): Promise<PagedData<Equipment>> {
    const pagedData = new PagedData<Equipment>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;
      params += '&contract_Number=' + contract_No;

      this.http.get<ServerData>(environment.apiUrl + 'equipment/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getAssetRegisterResults(page: Page, company_Id: number, location_Id: number, category_Id: number,
    serial_Num: string, asset_Num: string, contract_No: string, status: string, job_No: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;
      params += '&contract_Number=' + contract_No;
      params += '&status=' + status;
      params += '&job_No=' + job_No;

      this.http.get<ServerData>(environment.apiUrl + 'inspection/getAssetRegisterTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }



  public getExcel(page: Page, insurer_Id: number, broker_Id: number, company_Id: number, location_Id: number, category_Id: number, serial_Num: string, asset_Num: string): Promise<any> {

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Description'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;
      params += '&category_Id=' + category_Id;
      params += '&serial_Num=' + serial_Num;
      params += '&asset_Num=' + asset_Num;

      this.http.get<any>(environment.apiUrl + 'equipment/getexcel?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        let blob = this.convertBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);

      }, error => {
        reject();
      });
    });
  }

  convertBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
